import { getDownloadURL } from '../../libs/constants'
import BulletButton from '../babu/BulletButton'
import NavBar from '../common/NavBar'

export default function PaymentSuccessScreen() {
  return (
    <>
      <NavBar />
      <div className="container mt-navbarSpacing mb-30">
        <h2 className="babu-text-subtitle my-l">付款成功</h2>
        <BulletButton
          variant="solid"
          onClick={() => {
            window.location.href = getDownloadURL()
          }}>
          下載 aifian
        </BulletButton>
      </div>
    </>
  )
}
